import { useContext } from 'react';
import type { Actor } from 'domains-work-order-authorization';
import { UserDataContext } from 'lane-shared/contexts';
import { toActor } from './toActor';

export const useActor = (): Actor => {
  const { user } = useContext(UserDataContext);

  return toActor(user, new Date());
};
